import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from './services/environment.service';
@Injectable({ providedIn: 'root' })
export class WebtrekkConfigService {
    private isReady = false;
    private queue: Array<() => void> = [];
    constructor(@Inject(PLATFORM_ID) private platformId: Object, private enviornmentService: EnvironmentService) { }

    initWebtrekk() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }// SSR-safe

        const trackId = this.enviornmentService.getConfig()?.webtrekk.trackId;
        const trackDomain = this.enviornmentService.getConfig()?.webtrekk.trackDomain;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'webtrekk/loader.min.js'; // Replace with actual script src

        script.onload = () => {

            const waitForWtSmart = setInterval(() => {
                if ((window as any).wtSmart && (window as any).wtSmart.init) {
                    clearInterval(waitForWtSmart);

                    (window as any).wtSmart.init.set({
                        trackId: trackId,
                        trackDomain: trackDomain,
                        pageParameter: true
                    });
                    (window as any).wtSmart.track();
                    this.isReady = true;
                    this.flushQueue();
                }
            }, 100);
        };
        document.head.appendChild(script);
    }
    private flushQueue() {
        while (this.queue.length) {
            const fn = this.queue.shift();
            fn && fn()
        }
    }
    runWhenReady(fn: () => void) {
        if (this.isReady && (window as any).wtSmart) {
            fn();
        }
        else {
            this.queue.push(fn);
        }
    }
}
